<form [formGroup]="formGroup">


  <div class="row">
    <div [class.col-3]="inline" [class.col-12]="!inline">
      <label class="form-label">{{placeholder}}</label>
    </div>

    <div [class.col-4]="inline" [class.col-6]="!inline">
      <app-form-group
        class="w-100"
        [formControl]="formGroup.controls.min"
        type="text"
        placeholder="Min."
        name="{{ name }}_min"
        [small]="small"
      ></app-form-group>

    </div>

    <div [class.col-5]="inline" [class.col-6]="!inline">
      <app-form-group
        class="w-100"
        [formControl]="formGroup.controls.max"
        type="text"
        placeholder="Max."
        name="{{ name }}_max"
        [small]="small"
      ></app-form-group>
    </div>

  </div>
</form>
